import { TopChannel } from '../hooks/useTopChannels';
import { formatViewCount } from '../utils/format';

interface ChannelsHubPageProps {
  channels: TopChannel[];
  onSelectChannel: (channelId: string) => void;
  compareIds?: string[];
  onCompareToggle?: (channel: TopChannel) => void;
}

/** Ranking of the top-tracked YouTube channels by total views — /channels. */
export function ChannelsHubPage({ channels, onSelectChannel, compareIds = [], onCompareToggle }: ChannelsHubPageProps) {
  return (
    <div className="channels-hub">
      {channels.length > 1 && (
        <p className="ranking-compare-link">
          <a href={`/compare/channels/${channels[0].channelId}/${channels[1].channelId}`}>Compare the top two channels →</a>
        </p>
      )}
      <ol className="channels-hub-list">
        {channels.map((c, i) => (
          <li key={c.channelId} className="channels-hub-item">
            <button className="channels-hub-link" onClick={() => onSelectChannel(c.channelId)}>
              <span className="channels-hub-rank">#{i + 1}</span>
              <span className="channels-hub-name">{c.title}</span>
              <span className="channels-hub-meta">
                {formatViewCount(c.totalViews)} views · {c.videoCount} video{c.videoCount === 1 ? '' : 's'}
              </span>
            </button>
            {onCompareToggle && <button
              className={`channel-compare-button ${compareIds.includes(c.channelId) ? 'selected' : ''}`}
              onClick={() => onCompareToggle(c)}
              aria-pressed={compareIds.includes(c.channelId)}
            >{compareIds.includes(c.channelId) ? '✓ Selected' : '⚖ Compare'}</button>}
          </li>
        ))}
      </ol>
    </div>
  );
}
